<template>
  <div class="wrapper">
    <div
      class="section page-newStatus-header header-filter"
      :style="headerStyle"
    >
      <div class="container">
        <div class="md-layout">
          <div
            class="md-layout-item md-size-66 md-small-size-100 md-xsmall-size-100 md-medium-size-66 mx-auto md-scrollbar"
          >
            <div>
              <status-card header-color="green">
                <template v-slot:title>
                  <h4 class="card-title">Neuer Status</h4>
                </template>
                <template v-slot:goal>
                  <span><b>Wochenziel:</b></span>
                  <p
                    style="margin-left: 5px; overflow-wrap: anywhere"
                    v-if="currentGoal.text"
                  >
                    {{ currentGoal.text }}
                  </p>
                  <p
                    style="margin-left: 5px; overflow-wrap: anywhere"
                    v-if="!currentGoal.text"
                  >
                    Bitte lege ein
                    <router-link to="/weekGoal"
                      >Wochenziel
                      <i class="material-icons">event</i></router-link
                    >
                    fest.
                  </p>
                  <p>
                    <b>Gültig ab: </b
                    >{{
                      new Date(currentGoal.valid_from).toLocaleDateString(
                        "de-DE"
                      )
                    }}
                  </p>
                  <p>
                    <b>Zielerreichung: {{ batteryGoal }} %</b>
                  </p>
                  <md-progress-bar
                    class="md-primary"
                    md-mode="determinate"
                    :md-value="batteryGoal"
                  ></md-progress-bar>
                </template>
                <template v-slot:description>
                  <br />
                </template>
                <template v-slot:inputs>
                  <md-field class="md-form-group">
                    <md-icon>battery_unknown</md-icon
                    ><span class="md-prefix">%</span>
                    <label
                      >Zu wieviel Prozent hast du dein Ziel erreicht?</label
                    >
                    <md-input
                      v-model.number="battery"
                      type="number"
                      :max="100"
                      :min="0"
                    ></md-input>
                  </md-field>
                  <md-field class="md-form-group">
                    <md-icon>add_reaction</md-icon>
                    <label
                      style="
                        font-size: 0.6875rem:
                      "
                      >Wie geht es dir?</label
                    >
                    <div
                      class="md-layout"
                      style="
                        margin-left: 10px;
                        margin-bottom: 30px;
                        margin-top: 15px;
                      "
                    >
                      <div v-for="e in emojies" v-bind:key="e.name">
                        <md-radio v-model="emoji" :value="e.name">
                          <md-avatar> <img :src="e.img" /> </md-avatar
                        ></md-radio>
                      </div>
                    </div>
                  </md-field>
                  <md-field class="md-form-group">
                    <md-icon>textsms</md-icon>
                    <label>Gab es was Besonderes heute?</label>
                    <md-textarea v-model="text" md-autogrow></md-textarea>
                  </md-field>
                  <!-- <router-link
                    :to="{
                      name: 'chat',
                      params: {
                        status_prop: status,
                        currentGoal_prop: currentGoal,
                      },
                    }"
                  > -->
                  <md-button
                    class="md-simple md-success md-lg"
                    @click="sendStatus"
                  >
                    Speichern
                  </md-button>
                  <!-- </router-link> -->
                </template>
              </status-card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { StatusCard } from "@/components";
// import Chat from "@/components/Chat";

export default {
  components: {
    StatusCard,
  },
  bodyClass: "newStatus-page",
  data() {
    return {
      status: [],
      currentGoal: {
        _id: "",
        text: "",
        vaild_from: "",
      },
      text: "",
      emoji: "",
      battery: 0,
      batteryGoal: 0,
      showDialog: false,
      emojies: [
        { name: "e1", img: require("@/assets/img/emojis/e1.png") },
        { name: "e2", img: require("@/assets/img/emojis/e2.png") },
        { name: "e3", img: require("@/assets/img/emojis/e3.png") },
        { name: "e4", img: require("@/assets/img/emojis/e4.png") },
        { name: "e5", img: require("@/assets/img/emojis/e5.png") },
        { name: "e6", img: require("@/assets/img/emojis/e6.png") },
        { name: "e7", img: require("@/assets/img/emojis/e7.png") },
        { name: "e8", img: require("@/assets/img/emojis/e8.png") },
        { name: "e9", img: require("@/assets/img/emojis/e9.png") },
        { name: "e10", img: require("@/assets/img/emojis/e10.png") },
        { name: "e11", img: require("@/assets/img/emojis/e11.png") },
        { name: "e12", img: require("@/assets/img/emojis/e12.png") },
      ],
    };
  },
  props: {
    header: {
      type: String,
      default: require("@/assets/img/backgrounds/background5.png"),
    },
    e1: {
      type: String,
      default: require("@/assets/img/emojis/e1.png"),
    },
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`,
      };
    },
  },
  watch: {
    status() {
      //this.scrollToEnd();
      //this.scrollToElement();
    },
  },
  mounted() {},
  methods: {
    // Goals
    async addGoal(newGoal) {
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();
      const res = await fetch(process.env.VUE_APP_API_URL + "api/v1/goals", {
        method: "POST",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token}`, // send the access token through the 'Authorization' header
        },
        body: JSON.stringify(newGoal),
      });

      const data = await res.json();
      console.log(data);
      // this.goals = [...this.goals, data];
    },
    async updateGoal(updatedGoal) {
      console.log(updatedGoal);
    },
    // async deleteGoal(_id) {
    //   const res = await fetch(process.env.VUE_APP_API_URL + `api/v1/goals/${_id}`, {
    //     method: "DELETE",
    //   });

    //   res.status === 200
    //     ? (this.goals = this.goals.filter((goal) => goal._id !== _id))
    //     : alert("Error deleteing goal");
    // },
    async fetchAllGoals() {
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();
      const res = await fetch(process.env.VUE_APP_API_URL + `api/v1/goals`, {
        headers: {
          Authorization: `Bearer ${token}`, // send the access token through the 'Authorization' header
        },
      });
      const data = await res.json();
      return data;
    },
    async fetchGoal(_id) {
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();
      const res = await fetch(
        process.env.VUE_APP_API_URL + `api/v1/goals/${_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`, // send the access token through the 'Authorization' header
          },
        }
      );
      const data = await res.json();
      return data;
    },
    async fetchGoalByWeek(week) {
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();
      const res = await fetch(
        process.env.VUE_APP_API_URL + `api/v1/goals/week/${week}`,
        {
          headers: {
            Authorization: `Bearer ${token}`, // send the access token through the 'Authorization' header
          },
        }
      );
      const data = await res.json();
      return data;
    },
    async fetchGoalsByWeek(week) {
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();
      const res = await fetch(
        process.env.VUE_APP_API_URL + `api/v1/goals/week/${week}`,
        {
          headers: {
            Authorization: `Bearer ${token}`, // send the access token through the 'Authorization' header
          },
        }
      );
      const data = await res.json();
      return data;
    },
    async fetchValidGoal() {
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();
      const res = await fetch(process.env.VUE_APP_API_URL + `api/v1/goals/0`, {
        headers: {
          Authorization: `Bearer ${token}`, // send the access token through the 'Authorization' header
        },
      });
      const data = await res.json();
      return data;
    },
    // Status
    async addStatus(newStatus) {
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      const res = await fetch(process.env.VUE_APP_API_URL + "api/v1/status", {
        method: "POST",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token}`, // send the access token through the 'Authorization' header
        },
        body: JSON.stringify(newStatus),
      });

      const data = await res.json();
      if (!res.ok)
        throw new Error(
          "Deine Nachricht konnte nicht gespeichert werden. Bitte versuche es erneut."
        );
      this.status = [...this.status, data];
      this.batteryGoal = this.getLatestBattery(this.status);
      this.battery = this.batteryGoal;
    },
    async deleteStatus(_id) {
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      const res = await fetch(
        process.env.VUE_APP_API_URL + `api/v1/status/${_id}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`, // send the access token through the 'Authorization' header
          },
        }
      );

      res.status === 200
        ? (this.status = this.status.filter((s) => s._id !== _id))
        : alert("Error deleteing status");
    },
    async fetchAllStatus() {
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      const res = await fetch(process.env.VUE_APP_API_URL + `api/v1/status`, {
        headers: {
          Authorization: `Bearer ${token}`, // send the access token through the 'Authorization' header
        },
      });
      const data = await res.json();
      return data;
    },
    async fetchStatus(_id) {
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      const res = await fetch(
        process.env.VUE_APP_API_URL + `api/v1/status/${_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`, // send the access token through the 'Authorization' header
          },
        }
      );
      const data = await res.json();
      return data;
    },
    async fetchAllStatusByGoal(goalId) {
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      const res = await fetch(
        process.env.VUE_APP_API_URL + `api/v1/status/goalId/${goalId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`, // send the access token through the 'Authorization' header
          },
        }
      );
      const data = await res.json();
      return data;
    },
    async sendStatus() {
      if (!this.text && !this.emoji) {
        console.log("Text:" + this.text + ", emoji:" + this.emoji);
        alert("Bitte wähle ein Emoji aus oder schreibe einen Text");
        return;
      }

      if (this.battery < 0 || this.battery > 100) {
        alert("Die Zielereichung muss zwischen 0% und 100% liegen");
        return;
      }

      const newStatus = {
        text: this.text,
        emoji: this.emoji,
        battery: this.battery,
        goalId: "0",
      };

      // waits until status is in the database
      try {
        await this.addStatus(newStatus);
      } catch (error) {
        alert(error.message || "Dein Status konnte nicht gespeichert werden.");
        return;
      }

      this.text = "";
      this.emoji = "";

      this.$router.push({
        name: "chat",
      });
    },
    getLatestBattery(status) {
      let battery = 0;

      if (!status) return battery;

      for (let index = status.length - 1; index >= 0; index--) {
        const s = status[index];
        if (typeof s.battery === "number") {
          battery = s.battery;
          break;
        }
      }

      return battery;
    },
  },
  async created() {
    const latestGoal = await this.fetchValidGoal();
    const status = await this.fetchAllStatusByGoal(latestGoal._id);

    this.batteryGoal = this.getLatestBattery(status);
    this.battery = this.batteryGoal;
    this.status = status;
    this.currentGoal = latestGoal;
  },
};
</script>

<style lang="css">
.md-content {
  max-height: 400px;
  overflow: auto;
}
</style>
